$j(function(){
	$j('.header').click(function(){
		$j('html, body').animate({
			scrollTop:$j('.equipement').offset().top
		}, 'slow');
	})
});
